import { createFilterOptions } from '@mui/material/Autocomplete'
import type { PickupLocation } from '@otw/models'
import type { Terminal } from '@otw/models/leads/terminals'
import { buildTerminalSearchText } from '@otw/models/leads/terminals'
import { resolveTerminalLocation } from '@/core/terminals/terminalAddress'

/** Autocomplete filter matching name, number, address, city, state, and zip. */
export function createTerminalFilterOptions(
  pickupLocations: PickupLocation[] | undefined,
) {
  return createFilterOptions<Terminal>({
    stringify: (terminal) =>
      buildTerminalSearchText(
        terminal,
        resolveTerminalLocation(terminal, pickupLocations),
      ),
  })
}
